<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Recebimentos de Boletos Garantidos</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-12">
                <input
                  style="width: 100%"
                  class="form-control"
                  placeholder="Busca: Entre com o NOME ou DOCUMENTO do cliente e pressione enter"
                  name="filtro_pesquisa"
                  ref="filtro_pesquisa"
                  type="text"
                  v-model="dados.pesquisa"
                  @keyup.enter="getDataTable"
                  >
              </div>
            </div>
            <div class="row" style="margin-top:15px">
              <div class="col-sm-12 table-responsive">
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="example1"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr role="row">
                      <th style="width: 9%">Garantia</th>
                      <th style="width: 20%">Cliente</th>
                      <th style="width: 14%">CPF/CNPJ</th>
                      <th style="width: 10%">Vencimento</th>
                      <th style="width: 11%">Valor</th>
                      <th style="width: 11%">Valor Atualizado</th>
                      <th style="width: 8%">Situação</th>
                      <th style="width: 7%">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="even" role="row" v-for="item in apiData.data" :key="item.id">
                      <td>{{ item.id }} - {{ item.digito }}</td>
                      <td>{{ item.garantia.pessoa.nome_razao }}</td>
                      <td>{{ item.garantia.pessoa.cpf_cnpj }}</td>
                      <td>{{ item.vencimento | dataFormatada }}</td>
                      <td>{{ item.valor_garantido | numberFormat(2, ',', '.') }}</td>
                      <td><strong>{{ item.valor_atualizado | numberFormat(2, ',', '.') }}</strong></td>
                      <td>GARANTIDO</td>
                      <td>
                        <button
                          class="btn btn-success btn-sm"
                          @click="receber(item.id)"
                          title="Receber"
                        >
                          <i class="fa fa-fw fa-thumbs-up"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div
                    class="col-sm-5"
                  >Mostrando {{ this.apiData.from }} até {{ this.apiData.to }} de {{ this.apiData.total }} registros encontrados.</div>
                  <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination :limit="5" :data="apiData" v-on:pagination-change-page="getDataTable">
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
export default {
  data: () => ({
    dados: {
      pesquisa: ""
    },
    apiData: {
      data: []
    }
  }),
  mounted() {
    this.getDataTable();
    this.$nextTick(() => {
      this.$refs.filtro_pesquisa.focus();
    });
  },

  methods: {
    receber(boletoId) {
      this.$swal({
        title: "Confirma recebimento?",
        text: "Voce não poderá reverter essa operação!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim, confirmo!"
      }).then(result => {
        if (result.value) {
          axios
            .post(
              `${this.$store.state.serverURI}/api/boleto/baixar/${
                boletoId
              }`,
              {},
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.$swal({
                type: response.data.status == 200 ? "success" : "error",
                title:
                  response.data.status == 200
                    ? "Tudo Certo!"
                    : "Ops! Ocorreu um erro.",
                text: response.data.msg,
                showConfirmButton: false,
                timer: 1500
              });
              this.getDataTable();
              if (response.data.status == 200) {
                window.open(`${this.$store.state.serverURI}/api/boleto/getComprovante/b902${
                  boletoId
                }82=4345`, '_blank');
              }
            })
            .catch(erro => {
              this.$swal({
                type: "error",
                title: "Ops! Ocorreu um erro.",
                text: erro,
                showConfirmButton: true
              });
            });
        }
      });
    },
    getDataTable(page) {
      if (typeof page === "undefined") {
        page = 1;
      }
      this.dados.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.dados;
      axios
        .get(`${this.$store.state.serverURI}/api/boleto/getAllPaginate`, config)
        .then(response => {
          this.apiData = response.data;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    }
  },
  watch: {
    page: function(val) {
      this.getDataTable();
    }
  },

  components: {}
};
</script>
<style>
td {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// index.vue?2272f942